import {
    createSeriesByMarque,
    createSeriesForYear,
    createSeriesBySecteurs,
    createSeriesByYears,
    createSeriesBySecteursAndMarque,
} from "./createSeries";

export type DiagramGroupBy = "secteur_nutriment" | "famille_nutriment" | "nutriment";

/**
 * Clé de regroupement des graphes, identique à celle qu'applique createSeries :
 * secteur × nutriment (cas A et B), famille × nutriment (cas D), nutriment seul
 * (cas C et E). C'est cette clé que le plan de pagination compte, et c'est elle
 * qui délimite un chargement : l'échelle Y et la légende d'unités d'un graphe se
 * calculent sur le groupe entier.
 */
export const getDiagramGroupBy = (activeFilters: any): DiagramGroupBy => {
    const avecSecteur = activeFilters?.filter_secteur && activeFilters.filter_secteur.length > 0;
    const avecMarque = activeFilters?.filter_type_marque && activeFilters.filter_type_marque.length > 0;

    if (!avecSecteur) {
        return "nutriment";
    }

    return avecMarque ? "famille_nutriment" : "secteur_nutriment";
};

/**
 * Construit les configurations Highcharts selon le cas A à E.
 */
export const createDiagramSeries = (activeFilters: any, data: any): any[] => {
    if (!data) {
        return [];
    }

    if (activeFilters?.filter_secteur && activeFilters?.filter_secteur.length > 0) {
        if (activeFilters?.filter_type_marque && activeFilters?.filter_type_marque.length > 0) {
            // D (plusieurs types)
            return createSeriesByMarque(data);
        } else if (activeFilters?.filter_annee && activeFilters?.filter_annee.length === 1) {
            // A (une seule année)
            return createSeriesForYear(data);
        }
        // B (plusieurs années)
        return createSeriesByYears(data);
    }

    if (activeFilters?.filter_type_marque && activeFilters?.filter_type_marque.length > 0) {
        // E pas de secteur et avec marques
        return createSeriesBySecteursAndMarque(data);
    }

    // C (pas de secteur)
    return createSeriesBySecteurs(data);
};
